import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import { AnimationManager } from 'core/modules/animation';

/**
 * @type {class}
 * @desc This view wraps navigation component of multi StepList manager.
 * @example
 * import { StepList } from 'module/multiStepListManager';
 */
export class StepList extends React.Component {
    constructor( props ) {
        super( props );

        // set a step wrapper component based on `animation` prop
        // when `animation` prop is provided, it will be wrapped with `AnimationManager` to control animations
        this.StepWrapper = ! isEmpty( props.animation ) ? AnimationManager : React.Fragment;

    }

    render() {
        log.debug( 'StepList.render()' );

        // get context consumer
        const { Consumer } = this.props.context;

        return (
			<Consumer>
                { ( { activeStepIndex, setStepsCount, showMultiSteps } ) => { // showMultiSteps is a flag that enables step list to render multiple steps at a time; i.e. step list renders steps from index 0 to activeStepIndex

					// inform total step count to the parent
					setStepsCount( this.props.children.length );

					// in case show multi step flag is true then return array of children starting from 0 to active step index; otherwise mount single child with active step index
                    const children = showMultiSteps ? this.props.children.slice( 0, activeStepIndex + 1 ): [ this.props.children[ activeStepIndex ] ];

					// render with animation manager
                    return (
                        <this.StepWrapper>
                            {
                                map( children, ( child, index ) => {
                                    return(
                                        React.cloneElement( child, {
											key: showMultiSteps ? index : activeStepIndex,
											stepIndex: showMultiSteps ? index : activeStepIndex,
                                            animation: this.props.animation
                                        } )
                                    );
                                } )
                            }
                        </this.StepWrapper>
                    );
                } }
            </Consumer>
        );

    }
}

// display name
StepList.displayName = 'StepList';

// prop types
StepList.propTypes = {
    context: PropTypes.any.isRequired,
    animation: PropTypes.shape( {
        name: PropTypes.string,
        settings: PropTypes.object
    } )
};

// default props
StepList.defaultProps = {
    animation: null
};
